export default __webpack_public_path__ + "img/Montserrat-Thin_446ea18.woff";